const OptionFormTypes = {
  TYPE_CONTAINS: 'TYPE_CONTAINS',
  TYPE_STRING: 'TYPE_STRING',
  TYPE_NUMBER_COMPARISON: 'TYPE_NUMBER_COMPARISON',
  TYPE_CURRENCY_COMPARISON: 'TYPE_CURRENCY_COMPARISON',
  TYPE_DATE_COMPARISON_DEPRECATED: 'TYPE_DATE_COMPARISON_DEPRECATED', // TODO: Remove when no longer in use per SPD-1623 - Greg S 1/10/20
  TYPE_ORDER_DATE_COMPARISON: 'TYPE_ORDER_DATE_COMPARISON',
  TYPE_DATE_COMPARISON: 'TYPE_DATE_COMPARISON',
  TYPE_DATE_COMPARISON_SHIPMENTS: 'TYPE_DATE_COMPARISON_SHIPMENTS',
  TYPE_IS_OPTIONS: 'TYPE_IS_OPTIONS',
  TYPE_IS_RADIO_OPTIONS: 'TYPE_IS_RADIO_OPTIONS',
  TYPE_BOOLEAN: 'TYPE_BOOLEAN',
  TYPE_IS_FREE_INPUT_DEPRECATED: 'TYPE_IS_FREE_INPUT_DEPRECATED', // TODO: Remove when no longer in use per SPD-1566 - Greg S 1/7/20
  TYPE_CHECKLIST: 'TYPE_CHECKLIST',
  TYPE_IS_OR_ISNOT_MULTI_OPTIONS: 'TYPE_IS_OR_ISNOT_MULTI_OPTIONS',
  TYPE_ORDER_COLLECTION_FILTER: 'TYPE_ORDER_COLLECTION_FILTER', // TODO: when customers filters support this we can drop 'ORDER' out of the name and consolidate
  TYPE_ORDER_COLLECTION_FILTER_OR_BLANK: 'TYPE_ORDER_COLLECTION_FILTER_OR_BLANK',
};

export const stringOptionFormTypes = new Set([
  OptionFormTypes.TYPE_CONTAINS,
  OptionFormTypes.TYPE_STRING,
  OptionFormTypes.TYPE_IS_FREE_INPUT_DEPRECATED,
]);

export const numericOptionFormTypes = new Set([OptionFormTypes.TYPE_NUMBER_COMPARISON, OptionFormTypes.TYPE_CURRENCY_COMPARISON]);

export const dateOptionFormTypes = new Set([
  OptionFormTypes.TYPE_DATE_COMPARISON_DEPRECATED,
  OptionFormTypes.TYPE_ORDER_DATE_COMPARISON,
  OptionFormTypes.TYPE_DATE_COMPARISON,
  OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS,
]);

export const collectionOptionFormTypes = new Set([
  OptionFormTypes.TYPE_IS_OPTIONS,
  OptionFormTypes.TYPE_IS_RADIO_OPTIONS,
  OptionFormTypes.TYPE_CHECKLIST,
  OptionFormTypes.TYPE_IS_OR_ISNOT_MULTI_OPTIONS,
  OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER_OR_BLANK,
]);

export { OptionFormTypes };
